module.exports = __webpack_public_path__ + "static/media/sipora_transparent.4eb6f15c.png";